/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  KillswitchOverlap,
  KillswitchOverlap$inboundSchema,
} from "./killswitchoverlap.js";

export type KillswitchPreviewOverlapsResult = {
  overlaps: Array<KillswitchOverlap>;
  truncated: boolean;
};

/** @internal */
export const KillswitchPreviewOverlapsResult$inboundSchema: z.ZodMiniType<
  KillswitchPreviewOverlapsResult,
  unknown
> = z.object({
  overlaps: z.array(KillswitchOverlap$inboundSchema),
  truncated: z.boolean(),
});

export function killswitchPreviewOverlapsResultFromJSON(
  jsonString: string,
): SafeParseResult<KillswitchPreviewOverlapsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => KillswitchPreviewOverlapsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'KillswitchPreviewOverlapsResult' from JSON`,
  );
}
